import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Get child subject tests for parent
export const getChildSubjectTests = createAsyncThunk(
  "childTests/getChildSubjectTests",
  async ({ childId, subjectId = 0, page = 1, perPage = 10 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/parent/child_sub_tests/${subjectId}?child_id=${childId}&page=${page}&per_page=${perPage}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب الاختبارات");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

const initialState = {
  childSubjectTests: null,
  childSubjectTestsLoading: false,
  error: null,
};

const childTestsSlice = createSlice({
  name: "childTests",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChildSubjectTests.pending, (state) => {
        state.childSubjectTestsLoading = true;
        state.error = null;
      })
      .addCase(getChildSubjectTests.fulfilled, (state, action) => {
        state.childSubjectTestsLoading = false;
        state.childSubjectTests = action.payload;
      })
      .addCase(getChildSubjectTests.rejected, (state, action) => {
        state.childSubjectTestsLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = childTestsSlice.actions;
export default childTestsSlice.reducer;
